import { render, staticRenderFns } from "./POShare.vue?vue&type=template&id=037916d0"
import script from "./POShare.vue?vue&type=script&lang=js"
export * from "./POShare.vue?vue&type=script&lang=js"
import style0 from "./POShare.vue?vue&type=style&index=0&id=037916d0&prod&lang=css"
import style1 from "./POShare.vue?vue&type=style&index=1&id=037916d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports